import { useState } from "react";
import Form from "../Form";
import contactImg from "../../assets/images/contact-img.jpg";

export default function Contact() {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText("charismaticconsultingandservices.com");
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <div className="container relative py-16 md:py-[200px] flex md:flex-row flex-col">
      <div className="w-full flex-col justify-start items-start flex bg-white">
        <img
          src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Rectangle1-5e95d4a7-88c5-4fb6-9b50-e7b95bc5bffc.svg"
          alt="Rectangle 1"
          style={{ justifySelf: "anchor-center" }}
          className="absolute top-0 left-0 right-0 w-10 md:w-auto"
        />
        <div className="flex-col justify-center w-full items-center gap-2 mx-auto flex max-w-[852px] mb-8 md:mb-14">
          <div className="p-2 bg-[#e6f1ff] rounded-md justify-center items-center gap-2 inline-flex">
            <div className="whitespace-nowrap text-[#2b8cff] text-base font-medium font-secondary leading-[19px]">
              CONTACT
            </div>
          </div>
          <div className="text-center text-[#0e0e0e] text-2xl md:text-[32px] font-semibold font-primary leading-[41.60px]">
            Ready to Optimize Your Industrial Operations?
          </div>
          <div className="text-center text-[#373737] text-base md:text-xl font-light font-primary leading-7 tracking-[0.01em]">
            Contact Charles today to discuss challenges in cosmetics,
            ammunition, or refrigeration operations — and how Lean Six Sigma
            projects can deliver immediate, lasting results.
          </div>
        </div>
        <div
          className="w-full lg:w-auto lg:justify-start justify-between lg:items-start
        items-center gap-6 xl:gap-x-[106px] flex flex-col lg:flex-row mx-auto"
        >
          <img
            src={contactImg}
            alt="Component 48"
            className="object-cover inset-0 w-full max-w-[530px] h-full lg:h-[859px] object-center rounded-md"
          />
          <div className="flex-col justify-center items-center gap-8 inline-flex w-full">
            <div className="flex-col justify-center lg:justify-start items-center lg:items-start gap-8 flex">
              <div className="justify-start items-center gap-3 inline-flex">
                <img
                  src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Frame-682c6b44-ca0f-4379-bb8d-6ef2aab9b7ef.svg"
                  alt="Frame"
                />
                <div className="whitespace-nowrap text-[#373737] text-sm md:text-xl font-normal font-primary underline leading-7 tracking-[0.01em]">
                  <a href="mailto:charles@charismaticconsultingandservices.com">
                    charles@charismaticconsultingandservices.com
                  </a>
                </div>
              </div>
              <div className="justify-start items-center gap-3 inline-flex">
                <img
                  src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Frame-ed7bb791-1c75-4d70-99ea-2653744f6028.svg"
                  alt="Frame"
                />
                <div className="relative whitespace-nowrap text-[#373737] text-sm md:text-xl font-normal font-primary underline leading-7 tracking-[0.01em]">
                  <div onClick={handleCopy} className="cursor-pointer">
                    charismaticconsultingandservices.com
                  </div>
                  {copied && (
                    <div
                      className="absolute bottom-[-24px] shadow left-0 bg-white rounded border border-gray-300 p-1
                    text-xs font-normal font-primary"
                    >
                      Copied to clipboard
                    </div>
                  )}
                </div>
              </div>
              <div className="justify-start items-center gap-3 inline-flex">
                <img
                  src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Frame-55e0a994-c4c5-40a3-9fb4-c7ec5fa2a62c.svg"
                  alt="Frame"
                />
                <div className="whitespace-nowrap text-[#373737] text-sm md:text-xl font-normal font-primary underline leading-7 tracking-[0.01em] cursor-pointer">
                  <a
                    target="_blank"
                    href="https://calendly.com/charismaticconsultingar/"
                  >
                    Schedule your free consultation
                  </a>
                </div>
              </div>
            </div>
            <Form />
          </div>
        </div>
      </div>
    </div>
  );
}
